// Event Action Types
export const ADD_EVENT = 'ADD_EVENT';

// Chat Action Types
export const HANDLE_FILTER_USER = 'HANDLE_FILTER_USER';
export const HANDLE_SELECT_USER = 'HANDLE_SELECT_USER';
export const HANDLE_SEND_MESSAGE = 'HANDLE_SEND_MESSAGE';

// Drivers Action Types
export const PENDING_DRIVERS_LOADING = 'PENDING_DRIVERS_LOADING';
export const PENDING_DRIVERS_STOP_LOADING = 'PENDING_DRIVERS_LOADING';
export const SET_PENDING_DRIVERS = 'SET_PENDING_DRIVERS';
export const SET_APPROVED_DRIVERS = 'SET_APPROVED_DRIVERS';

// Routers Action Types
export const SET_CURRENT_SEARCHING_COLLECTION = 'SET_CURRENT_SEARCHING_COLLECTION';
export const SET_CURRENT_SEARCHING_TERM = 'SET_CURRENT_SEARCHING_TERM';

// Employee Action Types
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';

// Travel Action Types
export const SET_TRAVELS = 'SET_TRAVELS';
export const SET_IS_FILTERED = 'SET_IS_FILTERED';
export const SET_FILTERS = 'SET_FILTERS';

// Driver Action Types
export const SET_DRIVER = 'SET_DRIVER';
